import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20product%20display%20featuring%20diverse%20fashion%20items%20including%20shoes%20bags%20and%20accessories%20artfully%20arranged%20on%20warm%20cream%20surface%20with%20natural%20textures%2C%20soft%20golden%20hour%20backlight%20creating%20warm%20highlights%2C%20stylized%20editorial%20product%20photography%20with%20shallow%20depth%20of%20field%2C%20warm%20amber%20and%20honey%20color%20palette%2C%20luxurious%20retail%20display%20concept%20with%20organic%20elements%20and%20dried%20flowers&width=1600&height=600&seq=vigorbuy-cta-04&orientation=landscape"
          alt="Vigorbuy Spreadsheet call to action background"
          title="Start Your Research with Vigorbuy Spreadsheet"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/55 to-black/35"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          Ready to Explore Vigorbuy Spreadsheet?
        </h2>
        <p className="text-background-50/70 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
          Start browsing product categories, read our comprehensive guides, and make smarter shopping decisions today.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            <i className="ri-shopping-cart-line mr-2"></i>
            Buy It Now
          </a>
          <Link
            to="/vigorbuy-spreadsheet-beginner-guide"
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-base hover:bg-background-50/25 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-book-open-line mr-2"></i>
            Read Beginner Guide
          </Link>
        </div>
      </div>
    </section>
  );
}